module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_blue_selected.e76202ff.svg";